import Vue from "vue";
import deepEqual from "fast-deep-equal";

export default {
  state: {
    filterRules: [],

    // NB: EC-621 reference to map conceptItem URI values (e.g. FILTER_AREA) resolved
    // human-readable text from the newsitem service. Indexed by "type" and "uri".
    valuesMap: {}
  },

  getters: {
    getFilterRulesByType: ({ filterRules }) => type =>
      filterRules.filter(filterRule => filterRule.type === type),
    getFilterRule: ({ filterRules }) => ({ type, values }) =>
      filterRules.find(f => deepEqual({ type, values }, f))
  },

  mutations: {
    setFilterRules(state, { filterRules }) {
      Vue.set(state, "filterRules", filterRules);
    },

    setValuesMap(state, valuesMap) {
      Vue.set(state, "valuesMap", valuesMap);
    },

    addFilterRule({ filterRules }, { filterRule }) {
      Vue.set(filterRules, filterRules.length, filterRule);
    },

    replaceFilterRuleByType({ filterRules }, { filterRule }) {
      const { type } = filterRule;
      const ruleIndex = filterRules.findIndex(rule => rule.type === type);

      if (ruleIndex > -1) {
        Vue.set(filterRules, ruleIndex, filterRule);
      }
    },

    setFilterRulesByType(state, { type, filterRules }) {
      const unchangedFilters = state.filterRules.filter(
        rule => rule.type !== type
      );

      Vue.set(state, "filterRules", [...unchangedFilters, ...filterRules]);
    },

    removeFilterRulesByType(state, { type }) {
      const unchangedFilters = state.filterRules.filter(rule => {
        if (rule.type !== type) {
          return true;
        }
        return false;
      });

      Vue.set(state, "filterRules", [...unchangedFilters]);
    },

    removeFilterRule(state, { filterRule }) {
      const index = state.filterRules.findIndex(f => deepEqual(filterRule, f));
      state.filterRules.splice(index, 1);
    }
  },

  namespaced: true
};
